import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-filtro-selecao', standalone: false,
  template: `
    <div ngbDropdown #menu="ngbDropdown" class="selecao" [autoClose]="'outside'">
      <button type="button" class="form-control form-control-sm text-left" ngbDropdownToggle [disabled]="disabled" [attr.aria-label]="label">
        {{ value || placeholder }}
      </button>
      <div ngbDropdownMenu class="w-100 p-2">
        <input type="search" class="form-control form-control-sm mb-2" placeholder="Digite para buscar..."
          [attr.aria-label]="'Buscar ' + label" [(ngModel)]="busca" [ngModelOptions]="{standalone: true}" />
        @if (permitirLimpar) {
          <button type="button" ngbDropdownItem (click)="selecionar(''); menu.close()">{{ placeholder }}</button>
        }
        <div class="opcoes">
          @for (opcao of filtradas; track opcao) {
            <button type="button" ngbDropdownItem [class.active]="opcao === value" (click)="selecionar(opcao); menu.close()">{{ opcao }}</button>
          }
          @if (!opcoes.length) { <small class="text-muted" role="status">{{ mensagemVazia }}</small> }
          @else if (!filtradas.length) { <small class="text-muted" role="status">Nenhum resultado para esta busca.</small> }
        </div>
      </div>
    </div>`,
  styles: [`.selecao { position: relative; } .opcoes { max-height: 220px; overflow: auto; } button.form-control { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; padding-right: 24px; } .dropdown-item { white-space: normal; }`]
})
export class FiltroSelecaoComponent {
  @Input() opcoes: string[] = [];
  @Input() value = '';
  @Input() label = '';
  @Input() placeholder = 'Todos';
  @Input() disabled = false;
  @Input() permitirLimpar = true;
  @Input() mensagemVazia = 'Nenhuma opção cadastrada.';
  @Output() valueChange = new EventEmitter<string>();
  busca = '';
  get filtradas(): string[] {
    const normalizar = (s: string) => s.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    return this.opcoes.filter(o => normalizar(o).includes(normalizar(this.busca)));
  }
  selecionar(value: string) { this.valueChange.emit(value); this.busca = ''; }
}
